import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Mail, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [debugResetUrl, setDebugResetUrl] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setDebugResetUrl("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/password/forgot", {
        email,
        origin_url: window.location.origin,
      });
      setMessage(data?.message || "Si ce compte existe, un lien de réinitialisation vient d'être envoyé.");
      if (data?.reset_url) setDebugResetUrl(data.reset_url);
    } catch (err) {
      setError(err?.response?.data?.detail || "Impossible de générer le lien de réinitialisation.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-12">
      <div className="card p-8 max-w-md w-full">
        <Link to="/login" className="text-sm text-gray-500 hover:text-brand-green inline-flex items-center gap-1 mb-6">
          <ArrowLeft className="w-4 h-4" /> Retour à la connexion
        </Link>
        <div className="w-12 h-12 rounded-xl bg-emerald-100 flex items-center justify-center mb-4">
          <Mail className="w-6 h-6 text-brand-green" />
        </div>
        <h1 className="font-heading text-3xl font-black mb-2">Mot de passe oublié</h1>
        <p className="text-gray-600 text-sm mb-6">
          Entre ton email. Si ton compte existe, tu recevras un lien pour choisir un nouveau mot de passe.
        </p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="label mb-1 block">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input"
              placeholder="ton@email.com"
              data-testid="forgot-password-email"
            />
          </div>
          {message && <p className="rounded-lg bg-emerald-50 border border-emerald-200 text-emerald-700 text-sm p-3">{message}</p>}
          {debugResetUrl && (
            <p className="rounded-lg bg-amber-50 border border-amber-200 text-amber-700 text-sm p-3 break-all">
              Mode preview : <Link to={debugResetUrl.replace(window.location.origin, "")} className="underline font-semibold">ouvrir le lien de reset</Link>
            </p>
          )}
          {error && <p className="rounded-lg bg-red-50 border border-red-200 text-red-700 text-sm p-3">{error}</p>}
          <button disabled={loading} className="btn-primary w-full justify-center" data-testid="forgot-password-submit">
            {loading ? "Envoi..." : "Recevoir le lien"}
          </button>
        </form>
      </div>
    </div>
  );
}
